/**
 *  pictureView Module
 *
 * Description 图片展示组件
 * Author: Qian.qianchen 2018-11-26
 */
angular.module('weiboPictureViewModule', [])
    .directive('weiboPictureView', ['$q', 'trsHttpService', function($q, trsHttpService) {
        return {
            // name: '',
            // priority: 1,
            // terminal: true,
            scope: {
                thumbPictures: "=",
                needPrefix: "@",
                needCount: "@"
                // notAllowDragPic: "@"
            }, // {} = isolate, true = child, false/undefined = no change
            // controller: function($scope, $element, $attrs, $transclude) {},
            // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
            restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
            // template: '',
            templateUrl: './editingCenter/weibo/directive/pictureView/pictureView_tpl.html',
            replace: true,
            // transclude: true,
            // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
            link: function($scope, iElm, iAttrs, controller) {
                initStatus();
                initData();
                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        showThumb: true,
                        currentIndex: 0,
                        currrentPicture: {},
                        showCount: angular.isDefined($scope.needCount) && $scope.needCount == "true" ? true : false,
                        showMore: false,
                    };
                }

                function initData() {
                    if (angular.isUndefined($scope.thumbPictures)) {
                        return;
                    } else if (typeof($scope.thumbPictures) == "string") {
                        $scope.thumbPictures = $scope.thumbPictures.split(",");
                    }
                    if ($scope.thumbPictures.length == 1 && $scope.thumbPictures[0] == "") {
                        $scope.thumbPictures = [];
                    }
                }
                /**
                 * [magnify description] 图片放大查看
                 * @param  {[Int]} index   [description] 当前放大图片的索引值
                 * @param  {[String]} picture [description] 当前放大的图片链接
                 * @return {[type]}         [description]
                 */
                $scope.magnify = function(index, picture) {
                    if ($scope.status.showThumb) {
                        $scope.status.showThumb = !$scope.status.showThumb;
                    }
                    $scope.status.currentIndex = index;
                    $scope.status.currrentPicture = picture;
                }
                /**
                 * [goToPrev description] 上一张图片
                 * @return {[type]} [description]
                 */
                $scope.goToPrev = function() {
                    $scope.status.currentIndex--;
                    $scope.status.currrentPicture = $scope.thumbPictures[$scope.status.currentIndex];
                }
                /**
                 * [goToNext description] 下一张图片
                 * @return {[type]} [description]
                 */
                $scope.goToNext = function() {
                    $scope.status.currentIndex++;
                    $scope.status.currrentPicture = $scope.thumbPictures[$scope.status.currentIndex];
                }
                /**
                 * [urlFormat description] 图片地址拼接
                 * @param  {[type]} pictureUrl [description]
                 * @return {[type]}            [description]
                 */
                $scope.urlFormat = function(pictureUrl) {
                    if ($scope.needPrefix == "true") {
                        return '/wcm/app/scm/file/read_image.jsp?FileName=' + pictureUrl;
                    } else {
                        return pictureUrl;
                    }
                }

            }
        }
    }]);